<template>
  <div class="user-menu-container">
    <!-- 未登录状态 -->
    <button v-if="!authStore.isAuthenticated" class="premium-btn login-btn" @click="handleLogin">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="button-icon">
        <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
        <polyline points="10 17 15 12 10 7"></polyline>
        <line x1="15" y1="12" x2="3" y2="12"></line>
      </svg>
      <span>登录</span>
    </button>
    
    <!-- 已登录状态 -->
    <div v-else class="user-info-wrapper">
      <div class="user-avatar" @click="toggleDropdown">
        <img v-if="userAvatar" :src="userAvatar" alt="用户头像" class="avatar-image" />
        <div v-else class="avatar-placeholder">
          {{ userInitial }}
        </div>
        <span class="user-name">{{ userName }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="dropdown-arrow" :class="{ 'rotate': isDropdownOpen }">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </div>
      
      <!-- 下拉菜单 -->
      <transition name="slide-fade">
        <div v-show="isDropdownOpen" class="user-dropdown glass-panel">
          <div class="dropdown-header">
            <div class="avatar-large">
              <img v-if="userAvatar" :src="userAvatar" alt="用户头像" />
              <div v-else class="avatar-placeholder large">
                {{ userInitial }}
              </div>
            </div>
            <div class="user-details">
              <div class="user-name-large">
                {{ userName }}
                <span v-if="roleLabel" class="role-badge" :class="roleBadgeClass">{{ roleLabel }}</span>
              </div>
              <div class="user-email">{{ authStore.userInfo?.email }}</div>
              <div v-if="subscriptionTagText" class="subscription-row">
                <span class="subscription-tag" :class="subscriptionTagClass">
                  <span class="subscription-tag-label">{{ subscriptionTagText }}</span>
                </span>
                <span v-if="subscriptionMetaText" class="subscription-meta">{{ subscriptionMetaText }}</span>
              </div>
            </div>
          </div>
          
          <div class="dropdown-divider"></div>
          
          <button class="dropdown-item" @click="handleManageAccount">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="item-icon">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            <span>管理账号</span>
          </button>

          <button class="dropdown-item" @click="goEnvelopeAlerts">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="item-icon">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
              <line x1="12" y1="9" x2="12" y2="13"></line>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
            <span>异常待确认</span>
          </button>

          <button class="dropdown-item" @click="goEnvelopeHistory">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="item-icon">
              <path d="M3 3v18h18"></path>
              <path d="M19 7l-5 5-4-4-5 5"></path>
            </svg>
            <span>历史预警</span>
          </button>

          <button class="dropdown-item" @click="goEnvelopeSettings">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="item-icon">
              <circle cx="12" cy="12" r="3"></circle>
              <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"></path>
            </svg>
            <span>预警参数设置</span>
          </button>

          <button v-if="isAdmin" class="dropdown-item" @click="goDeviceManagement">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="item-icon">
              <path d="M12 2v2"></path>
              <path d="M12 20v2"></path>
              <path d="M4.93 4.93l1.41 1.41"></path>
              <path d="M17.66 17.66l1.41 1.41"></path>
              <path d="M2 12h2"></path>
              <path d="M20 12h2"></path>
              <path d="M4.93 19.07l1.41-1.41"></path>
              <path d="M17.66 6.34l1.41-1.41"></path>
              <path d="M12 8a4 4 0 1 0 0 8a4 4 0 0 0 0-8z"></path>
            </svg>
            <span>设备管理</span>
          </button>

          <button class="dropdown-item" @click="handleLogout">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="item-icon">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            <span>退出登录</span>
          </button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/store/auth'
import dayjs from 'dayjs'

export default {
  name: 'UserMenu',
  setup() {
    const authStore = useAuthStore()
    
    return {
      authStore
    }
  },
  data() {
    return {
      isDropdownOpen: false
    }
  },
  computed: {
    userName() {
      return this.authStore.userInfo?.username || 
             this.authStore.userInfo?.email || 
             '用户'
    },
    userAvatar() {
      return this.authStore.userInfo?.avatar || null
    },
    userInitial() {
      const name = this.userName
      return name ? name.charAt(0).toUpperCase() : 'U'
    },
    roleLabel() {
      const role = this.authStore.userInfo?.role
      if (role === 'superuser') return '超级管理员'
      if (role === 'admin') return '管理员'
      return ''
    },
    roleBadgeClass() {
      const role = this.authStore.userInfo?.role
      if (role === 'superuser') return 'superuser'
      if (role === 'admin') return 'admin'
      return ''
    },
    isAdmin() {
      const role = this.authStore.userInfo?.role
      return role === 'admin' || role === 'superuser'
    },
    subscriptionTagText() {
      const plan = this.authStore.userInfo?.subscription_plan
      const expires = this.authStore.userInfo?.subscription_expires
      if (!plan) return ''
      const isPremium = plan === 'premium'
      const t = expires ? dayjs(expires) : null
      const isExpired = t && t.isValid() ? t.isBefore(dayjs()) : false
      if (isExpired) return '订阅已到期'
      return isPremium ? '高级订阅' : '免费版'
    },
    subscriptionMetaText() {
      const plan = this.authStore.userInfo?.subscription_plan
      const expires = this.authStore.userInfo?.subscription_expires
      if (!plan) return ''
      if (!expires) return ''
      const t = dayjs(expires)
      if (!t.isValid()) return ''
      const now = dayjs()
      return t.isBefore(now) ? `已到期 ${t.format('YYYY-MM-DD')}` : `到期 ${t.format('YYYY-MM-DD')}`
    },
    subscriptionTagClass() {
      const plan = this.authStore.userInfo?.subscription_plan
      const expires = this.authStore.userInfo?.subscription_expires
      if (!plan) return ''
      const t = expires ? dayjs(expires) : null
      const isExpired = t && t.isValid() ? t.isBefore(dayjs()) : false
      if (isExpired) return 'expired'
      return plan === 'premium' ? 'premium' : 'free'
    }
  },
  created() {
    // 初始化认证状态
    this.authStore.initializeAuth()
    
    // 尝试获取用户信息（如果还没有）
    if (this.authStore.isAuthenticated && !this.authStore.userInfo) {
      this.authStore.fetchUserInfo().catch(err => {
        console.error('获取用户信息失败:', err)
      })
    }
    
    // 点击其他地方关闭下拉菜单
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isDropdownOpen = false
      }
    },
    
    handleLogin() {
      this.authStore.beginBrowserLogin(this.$route.fullPath)
    },

    handleManageAccount() {
      window.open('/api/auth/management/enter/?target=account&return_path=%2Fsettings%2Fprofile', '_blank', 'noopener')
      this.isDropdownOpen = false
    },

    goDeviceManagement() {
      this.isDropdownOpen = false
      this.$router.push({ name: 'DeviceManagement' })
    },

    goEnvelopeAlerts() {
      this.isDropdownOpen = false
      this.$router.push({ name: 'EnvelopePending' })
    },

    goEnvelopeHistory() {
      this.isDropdownOpen = false
      this.$router.push({ name: 'EnvelopeHistory' })
    },

    goEnvelopeSettings() {
      this.isDropdownOpen = false
      this.$router.push({ name: 'EnvelopeAlertSettings' })
    },
    
    async handleLogout() {
      try { await this.authStore.logout() }
      catch { window.alert('退出未完成，请稍后重试。') }
    }
  }
}
</script>

<style scoped>
.user-menu-container {
  position: relative;
  display: inline-block;
}

/* 登录按钮 */
.login-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background-size: 200% auto;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 20px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 6px rgba(118, 75, 162, 0.2);
}

.login-btn:hover {
  background-position: right center;
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(118, 75, 162, 0.5);
}

.login-btn:active {
  transform: translateY(0);
}

/* 用户信息区域 */
.user-info-wrapper {
  position: relative;
}

.user-avatar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 16px 4px 4px;
  background: rgba(15, 23, 42, 0.6);
  border-radius: 32px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(8px);
}

.user-avatar:hover {
  background: rgba(15, 23, 42, 0.8);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.user-avatar:active {
  transform: translateY(0);
}

.avatar-image {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.1);
  transition: border-color 0.3s ease;
}

.user-avatar:hover .avatar-image {
  border-color: #00f0ff;
}

.avatar-placeholder {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
  text-shadow: 0 1px 2px rgba(0,0,0,0.2);
  border: 2px solid rgba(255, 255, 255, 0.1);
  box-shadow: inset 0 2px 4px rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.user-avatar:hover .avatar-placeholder {
  border-color: #00f0ff;
  box-shadow: 0 0 10px rgba(0, 240, 255, 0.3);
}

.user-name {
  color: #e2e8f0;
  font-size: 0.95rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: color 0.3s ease;
  max-width: 140px; /* Precaution for long names */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media screen and (max-width: 480px) {
  .user-name {
    max-width: 80px; /* Even smaller for mobile */
  }
}

.user-avatar:hover .user-name {
  color: white;
}

.dropdown-arrow {
  color: rgba(255, 255, 255, 0.5);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin-left: 4px;
}

.user-avatar:hover .dropdown-arrow {
  color: #00f0ff;
}

.dropdown-arrow.rotate {
  transform: rotate(180deg);
}

/* 下拉菜单 */
.user-dropdown {
  position: absolute;
  top: calc(100% + 16px);
  right: 0;
  width: 300px;
  max-width: calc(100vw - 32px);
  background: rgba(10, 15, 30, 0.95);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  box-shadow: 0 20px 50px -10px rgba(0, 0, 0, 0.8), 
              0 0 0 1px rgba(255, 255, 255, 0.05);
  z-index: 1000;
  overflow: hidden;
  transform-origin: top right;
  animation: dropdown-enter 0.2s ease-out;
}

@media screen and (max-width: 480px) {
  .user-dropdown {
    right: -10px; /* Slight offset to align better near edge */
    width: 280px;
  }
}

/* 下拉菜单头部 */
.dropdown-header {
  padding: 24px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.03), transparent);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.avatar-large {
  width: 64px;
  height: 64px;
  flex-shrink: 0;
  position: relative;
  margin-top: 2px;
}

.avatar-large img,
.avatar-placeholder.large {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
}

.avatar-placeholder.large {
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 28px;
  color: white;
  text-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.user-details {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
}

.user-name-large {
  color: white;
  font-size: 1.15rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: 0.5px;
}

.user-email {
  color: #94a3b8;
  font-size: 0.85rem;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
  opacity: 0.8;
}

.subscription {
  margin-top: 6px;
  color: rgba(148, 163, 184, 0.95);
  font-size: 0.82rem;
  line-height: 1.2;
}

.subscription-row {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.subscription-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  line-height: 24px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.4px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(148, 163, 184, 0.12);
  color: rgba(226, 232, 240, 0.92);
  position: relative;
  overflow: hidden;
  user-select: none;
  box-sizing: border-box;
  text-align: center;
  isolation: isolate;
}

.subscription-tag-label {
  position: relative;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  line-height: inherit;
}

.subscription-tag::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  pointer-events: none;
  z-index: 0;
}

.subscription-tag::after {
  content: '';
  position: absolute;
  top: -60%;
  left: -40%;
  width: 60%;
  height: 240%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.10) 35%,
    rgba(255, 255, 255, 0.30) 50%,
    rgba(255, 255, 255, 0.10) 65%,
    rgba(255, 255, 255, 0) 100%
  );
  transform: rotate(22deg);
  opacity: 0;
  transition: opacity 0.25s ease;
  pointer-events: none;
  z-index: 1;
}

.subscription-tag:hover::after {
  opacity: 1;
  animation: sub-shine 1.2s ease forwards;
}

@keyframes sub-shine {
  0% { transform: translateX(-20%) rotate(22deg); }
  100% { transform: translateX(240%) rotate(22deg); }
}

@keyframes sub-shine-low {
  0%, 68% { transform: translateX(-20%) rotate(22deg); opacity: 0; }
  72% { transform: translateX(-20%) rotate(22deg); opacity: 0.22; }
  100% { transform: translateX(240%) rotate(22deg); opacity: 0; }
}

.subscription-tag.premium {
  border-color: rgba(255, 230, 150, 0.95);
  background: rgba(201, 143, 24, 0.92);
  color: rgba(255, 250, 235, 0.96);
  text-shadow:
    -0.5px 0 rgba(60, 40, 0, 0.55),
    0.5px 0 rgba(60, 40, 0, 0.55),
    0 -0.5px rgba(60, 40, 0, 0.55),
    0 0.5px rgba(60, 40, 0, 0.55),
    0 2px 10px rgba(0, 0, 0, 0.25);
  box-shadow:
    0 14px 40px rgba(255, 193, 7, 0.18),
    0 0 0 1px rgba(255, 242, 204, 0.30) inset,
    0 0 0 2px rgba(60, 40, 0, 0.10) inset;
}

.subscription-tag.premium::before {
  background:
    repeating-linear-gradient(
      115deg,
      rgba(255, 255, 255, 0.00) 0px,
      rgba(255, 255, 255, 0.00) 6px,
      rgba(255, 255, 255, 0.05) 9px,
      rgba(255, 255, 255, 0.00) 14px
    );
  opacity: 0.55;
  mix-blend-mode: soft-light;
}

.subscription-tag.premium::after {
  animation: sub-shine-low 8s ease-in-out infinite;
}

.subscription-tag.premium:hover::after {
  opacity: 1;
  animation: sub-shine 1.2s ease forwards;
}

@media (prefers-reduced-motion: reduce) {
  .subscription-tag.premium::after {
    animation: none !important;
    opacity: 0 !important;
  }
}

.subscription-tag.free {
  border-color: rgba(148, 163, 184, 0.22);
  background: rgba(148, 163, 184, 0.10);
  color: rgba(226, 232, 240, 0.9);
}

.subscription-tag.expired {
  border-color: rgba(239, 68, 68, 0.35);
  background: rgba(239, 68, 68, 0.14);
  color: rgba(254, 202, 202, 0.95);
}

.subscription-meta {
  font-size: 12px;
  color: rgba(226, 232, 240, 0.82);
  font-weight: 600;
}

.role-badge {
  margin-left: 10px;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.06);
  color: rgba(226, 232, 240, 0.95);
  white-space: nowrap;
}

.role-badge.admin {
  border-color: rgba(0, 240, 255, 0.25);
  background: rgba(0, 240, 255, 0.12);
  color: #bff9ff;
}

.role-badge.superuser {
  border-color: rgba(245, 158, 11, 0.35);
  background: rgba(245, 158, 11, 0.14);
  color: #fde68a;
}

.dropdown-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.06);
  margin: 0;
}

/* 下拉菜单项 */
.dropdown-item {
  width: 100%;
  padding: 16px 24px;
  background: transparent;
  border: none;
  color: #cbd5e1;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.95rem;
  font-weight: 500;
}

.dropdown-item:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #00f0ff;
  padding-left: 28px;
}

.item-icon {
  color: #64748b;
  transition: color 0.2s ease;
}

.dropdown-item:hover .item-icon {
  color: #00f0ff;
}

/* 过渡动画 */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.3, 0, 0, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-15px) scale(0.95);
}
</style>
